import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Banertomumbaicab() {



const cardData = {
  keyword: " Baner to Mumbai Cabs ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Baner to Mumbai cab services, offering hassle-free transportation for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups ensure a smooth journey from Baner to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Baner to Mumbai cab travel.",

topPlaces: [
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves located within Sanjay Gandhi National Park in Mumbai. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip to explore these centuries-old caves, meditation halls, sculptures, and inscriptions. Surrounded by lush greenery, the site is perfect for history enthusiasts, photographers, and nature lovers seeking a unique cultural experience."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is one of Mumbai's most famous beaches, known for its lively atmosphere, delicious street food, and beautiful sunsets. Renting an Innova Crysta in Pune ensures a relaxing journey for families and groups planning a memorable beach outing. Visitors can enjoy local snacks, evening walks, and spectacular views of the Arabian Sea."
  },
  {
    title: "Mount Mary Basilica",
    description: "Mount Mary Basilica in Bandra is one of Mumbai's most visited churches, attracting thousands of devotees and tourists every year. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this beautiful hilltop church while enjoying peaceful surroundings and panoramic views of the Arabian Sea. The church is especially popular during the annual Mount Mary Fair."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest public aquariums and features an impressive collection of freshwater and marine species. Visitors hiring an Innova Crysta on rent in Pune can conveniently explore colorful fish, exotic aquatic life, and interactive exhibits. It is an excellent attraction for children, families, and marine life enthusiasts."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic waterfront promenade offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can relax by the coastline, enjoy fresh sea breezes, and capture beautiful sunset photographs. It is a perfect destination for evening outings and peaceful walks."
  },
  {
    title: "Madh Island",
    description: "Madh Island is a peaceful coastal destination known for its quiet beaches, fishing villages, and scenic surroundings. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to escape the city's hustle and bustle. The island is ideal for weekend getaways, beach walks, photography, and enjoying fresh seafood."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    description: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya is one of India's premier museums, housing remarkable collections of art, sculptures, manuscripts, and historical artifacts. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this iconic museum and discover India's rich cultural and artistic heritage in a beautifully preserved historic building."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece dedicated to meditation and inner peace. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a scenic drive to this magnificent monument near Gorai. The peaceful atmosphere, meditation center, and impressive golden dome make it one of Mumbai's most unique attractions."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also called Castella de Aguada, is a historic Portuguese fort offering stunning views of the Arabian Sea and Bandra-Worli Sea Link. Travelers renting an Innova Crysta in Pune can comfortably visit this heritage site, explore its ancient walls, and enjoy excellent photography opportunities overlooking Mumbai's coastline."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque destination surrounded by gardens, cafés, and modern city landmarks. Booking an Innova Crysta on rent in Pune allows families and groups to enjoy a relaxing road trip before spending time boating, walking along the lakeside, or dining at nearby restaurants. It is an excellent place to unwind during a Mumbai visit."
  }
],



services: [
{
name: "Baner to Mumbai Taxi Fare",
description: "Baner to Mumbai taxi fare services provide transparent pricing for travelers planning intercity trips from Baner in Pune to Mumbai. Passengers can check fare details based on vehicle type, toll charges, and driver allowance before booking. Vehicles are comfortable and suitable for highway travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and residential societies across Baner. Flexible booking options allow easy cab reservations."
},
{
name: "Baner to Mumbai One Way Cab",
description: "Baner to Mumbai one way cab service offers convenient single-trip transportation for travelers heading from Baner to Mumbai. Professional drivers ensure safe driving and punctual pickup services through the expressway route. Vehicles are well maintained and suitable for business travel, tourism visits, and airport transfers. Pickup services are available from homes, offices, hotels, and IT parks across Baner. Flexible booking options allow quick one-way cab reservations."
},
{
name: "Baner to Mumbai Taxi Service",
description: "Baner to Mumbai taxi service provides reliable intercity transportation for passengers traveling between Baner and Mumbai. Comfortable vehicles with experienced drivers ensure safe highway travel and punctual pickups. Pickup services are available from homes, offices, hotels, and corporate hubs in Baner. Ideal for corporate travel, tourism trips, and family visits. Flexible booking options allow convenient taxi reservations."
},
{
name: "Baner to Mumbai Airport Drop",
description: "Baner to Mumbai airport drop service offers reliable one-way transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure safe driving and timely arrival for flights. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Baner to Mumbai Airport Cab Service",
description: "Baner to Mumbai airport cab service provides dependable transportation for passengers heading to Mumbai Airport. Vehicles are well maintained and suitable for long-distance airport travel with ample luggage space. Professional drivers ensure punctual pickup and safe expressway journeys. Pickup services are available from homes, offices, hotels, and business hubs in Baner. Flexible booking options allow advance airport cab reservations."
},
{
name: "Baner to Mumbai Ertiga Cab Service",
description: "Baner to Mumbai Ertiga cab service offers spacious SUV transportation suitable for families and group travelers. The Ertiga vehicle provides comfortable seating and luggage space for highway journeys between Baner and Mumbai. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and residential complexes in Baner. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Baner to Mumbai International Airport Cab",
description: "Baner to Mumbai international airport cab service offers reliable transportation for passengers traveling to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for international travelers. Professional drivers ensure safe and punctual expressway travel. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow convenient airport ride scheduling."
},
{
name: "Baner to Mumbai Innova Crysta Cab",
description: "Baner to Mumbai Innova Crysta cab service offers premium SUV transportation for passengers seeking luxury travel. Innova Crysta vehicles provide spacious seating, smooth ride quality, and premium interiors suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and IT parks in Baner. Flexible booking options allow convenient luxury ride reservations."
},
{
name: "Baner to Mumbai Sedan Cab",
description: "Baner to Mumbai sedan cab service offers economical and comfortable transportation for passengers traveling between Baner and Mumbai. Sedan vehicles provide smooth highway travel suitable for business travelers and small families. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, and hotels in Baner. Flexible booking options allow easy cab reservations."
},
{
name: "Baner to Mumbai Swift Dzire Car",
description: "Baner to Mumbai Swift Dzire car service provides affordable sedan transportation for passengers traveling between Baner and Mumbai. The Swift Dzire offers comfortable seating and efficient highway travel. Professional drivers ensure safe driving and timely pickups across Baner. Pickup services are available from homes, offices, and hotels. Flexible booking options allow economical travel planning."
},
{
name: "Baner to Mumbai Round Trip",
description: "Baner to Mumbai round trip cab service provides convenient return transportation for travelers planning journeys between Baner and Mumbai. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and corporate hubs across Baner. Flexible booking options allow easy round-trip reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Flexible booking options allow convenient ride reservations."
},
{
name: "Baner to Mumbai Airport Cabs",
description: "Baner to Mumbai airport cabs service provides dependable transportation for travelers heading to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage capacity suitable for airport travel. Professional drivers ensure safe driving and punctual pickup services across Baner. Flexible booking options allow advance airport cab reservations."
},
{
name: "Baner to Airport Cabs Booking Online",
description: "Baner to airport cabs booking online service allows travelers to easily reserve taxis for airport transfers through online platforms. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow quick ride reservations."
},
{
name: "Baner to Andheri Cab Booking",
description: "Baner to Andheri cab booking service provides reliable intercity transportation for passengers traveling from Baner to Andheri in Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow convenient ride reservations."
},
{
name: "Baner to Borivali Cab Booking",
description: "Baner to Borivali cab booking service offers dependable transportation for passengers traveling between Baner and Borivali in Mumbai. Vehicles provide comfortable seating and safe highway travel with experienced drivers. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow easy cab reservations."
},
{
name: "Baner to Mumbai Central Cab",
description: "Baner to Mumbai Central cab service provides reliable transportation for passengers traveling to Mumbai Central railway station and nearby areas. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow convenient cab reservations."
},
{
name: "Baner to Bandra Cab",
description: "Baner to Bandra cab service offers convenient transportation for passengers traveling between Baner and Bandra in Mumbai. Vehicles provide comfortable seating and smooth expressway travel with experienced drivers. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow quick ride reservations."
},
{
name: "Baner to Dadar Cabs",
description: "Baner to Dadar cab service provides dependable transportation for travelers traveling between Baner and Dadar in Mumbai. Vehicles are well maintained and suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Baner. Flexible booking options allow convenient ride reservations."
},
{
name: "Velocity Cabs",
description: "Velocity Cabs provides professional cab services for local travel, airport transfers, and outstation journeys across Pune and Mumbai routes. Vehicles are well maintained and driven by experienced drivers ensuring safe and comfortable travel. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient ride reservations."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune and nearby destinations. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow easy cab reservations."
}
],

tableData: [
["Baner to Mumbai Taxi Fare","Baner to Mumbai One Way Cab"],
["Baner to Mumbai Taxi Service","Baner to Mumbai Airport Drop"],
["Baner to Mumbai Airport Cab Service","Baner to Mumbai Ertiga Cab Service"],
["Baner to Mumbai International Airport Cab","Baner to Mumbai Innova Crysta Cab"],
["Baner to Mumbai Sedan Cab","Baner to Mumbai Swift Dzire Car"],
["Baner to Mumbai Round Trip","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Baner to Mumbai Airport Cabs"],
["Baner to Airport Cabs Booking Online","Baner to Andheri Cab Booking"],
["Baner to Borivali Cab Booking","Baner to Mumbai Central Cab"],
["Baner to Bandra Cab","Baner to Dadar Cabs"],
["Velocity Cabs","Cab Service in Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Baner to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures a safe, smooth, and timely journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Baner to Mumbai cab services. Customers receive complete fare details including toll charges and driver allowances before confirming their booking."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Baner to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, a business trip, or a late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable and relaxing travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Baner to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Baner",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and commercial complexes across Baner and nearby areas like Aundh, Balewadi, Pashan, and Wakad."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Baner to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Baner to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Baner to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Baner to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Baner to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Baner to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Baner and Mumbai." },
  { question: "Do you provide pickup from homes and hotels in Baner?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and commercial locations across Baner." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book Baner to Mumbai cab service online?", answer: "Yes, customers can easily book Baner to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Joshi",
    feedback:
      "I chose Velocity Cabs for my Baner to Mumbai cab journey, and the experience was fantastic. The driver was professional, the vehicle was clean, and the ride was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback:
      "Traveling from Baner to Mumbai with Velocity Cabs was a great decision. The pickup was on time, the cab was well-maintained, and the journey was safe and relaxing.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Baner to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Baner to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis from Baner to Mumbai including sedan, Ertiga, Innova, and Innova Crysta for airport transfers and outstation travel. Enjoy safe, comfortable, and punctual rides with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Baner to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Baner to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Sedan, Ertiga, Innova & Crysta cabs available. Safe, reliable & comfortable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Banertomumbaicab;